import { HTMLAttributes, useEffect } from "react";
import { initTemporaryDashboardQR } from "@/helper/helper";
import classes from "./GoogleButton.module.scss";
import classNames from "classnames";
import { Spinner } from "../Spinner";
import { FcGoogle } from "react-icons/fc";
import IFThen from "@/components/common/IFThen";
type VariantType = "primary" | "ghost";
type SizeType = "normal" | "large" | "small";
type Props = {
  redirectLink?: string;
  text: string;
  variant?: VariantType;
  size?: SizeType;
  loading?: boolean;
} & HTMLAttributes<HTMLAnchorElement>;
export function GoogleButton({
  redirectLink,
  text,
  loading = false,
  variant = "primary",
  size = "normal",
  onClick,
  ...res
}: Props) {
  useEffect(() => {
    initTemporaryDashboardQR();
  }, []);
  const fontSizeMap = {
    normal: "16px",
    small: "14px",
    large: "18px"
  };
  const fontSize = fontSizeMap[size];
  return <span className={classNames(classes.externalLink, {
    [classes.Primary]: variant === "primary",
    [classes.disabled]: loading,
    [res.className as string]: res.className
  })} data-sentry-component="GoogleButton" data-sentry-source-file="GoogleButton.tsx">
      <IFThen condition={loading} Then={<Spinner />} Else={<a id={res.id} style={{
      fontSize
    }} onClick={onClick}>
            <FcGoogle size={24} />
            {text}
          </a>} data-sentry-element="IFThen" data-sentry-source-file="GoogleButton.tsx" />
    </span>;
}